import { NoEcommerce } from '@/scripts/libs/no-ecommerce'
import { Cookies } from '@/scripts/libs/cookies'
import { ALREADY_CLOSED, ALREADY_SIGNED } from '@/scripts/constants/cookies'
import wcs from '@/scripts/libs/wcs/index'

const { newsletterOverlay, pagesWithoutNewsletter, viewTaskName } = wcs.getStoreConfig()

class NewsletterModal {
  isHidden = (isMobile: boolean) => {
    if (!this.isEnabled(isMobile)) {
      return true
    }
    return this.isAlreadyClosedOrSigned()
  }

  isEnabled = (isMobile: boolean) => {
    const isEnabledForCurrentDevice = isMobile
      ? newsletterOverlay.isEnabledForMobile
      : newsletterOverlay.isEnabledForDesktop
    return (
      !pagesWithoutNewsletter?.includes(viewTaskName) &&
      !NoEcommerce.isStoreNoEcommerce() &&
      newsletterOverlay.isEnabled &&
      isEnabledForCurrentDevice &&
      !this.isPromoApplied()
    )
  }

  isAlreadyClosedOrSigned = () => {
    const alreadySigned = Cookies.get(ALREADY_SIGNED)
    const alreadyClosed = Cookies.get(ALREADY_CLOSED)
    return alreadyClosed === 'true' || alreadySigned === 'true'
  }

  isPromoApplied = () => {
    return !!window.sessionStorage.getItem('promoCodeToApplyEvaluateQuery')
  }
}

export default new NewsletterModal()
